import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import EditTabUiComponent from '@iupics-components/standard/layouts/edit-tab-ui/edit-tab-ui.component';
import { AbstractDataContainer, AbstractDataContainerCallout } from '@iupics-manager/models/abstract-datacontainer';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'iu-comment-ui',
  templateUrl: './comment-ui.component.html',
  styleUrls: ['./comment-ui.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  // record data shown as HTML: Angular sanitizes it (the bypass pipe let stored scripts run for every viewer)
  imports: [],
})
export default class CommentUiComponent extends AbstractDataContainer implements OnInit, AfterViewInit {
  @Input()
  placeHolder: string;
  @ViewChild('input', { static: true })
  inputRef: ElementRef;
  @ViewChild('opConflict', { static: true })
  opConflict: OverlayPanel;
  dataContainers: AbstractDataContainerCallout;

  @Output() fieldValueChange = new EventEmitter<any>();
  @Output() enterKey = new EventEmitter<any>();

  ngOnInit() {
    super.ngOnInit();
    if (this.cssClass !== undefined) {
      this.cssGrid = this.cssClass;
    }
    this.cssClass = ' ' + this.cssGrid;
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    let parentComp = this.DOMParentComponent;
    while (parentComp && !(parentComp instanceof EditTabUiComponent)) {
      parentComp = parentComp.DOMParentComponent;
    }
    if (parentComp instanceof EditTabUiComponent) {
      this.dataContainers = new AbstractDataContainerCallout(parentComp.dataContainers);
    }
  }
}
